export const SET_BASIC_USER_INFO = 'SET_BASIC_USER_INFO';
export const SET_GUARDIAN_INFORMATION = 'SET_GUARDIAN_INFORMATION';
export const SIGNUP_ERROR = 'SIGNUP_ERROR';
export const CLEAR_SIGNUP_ERROR = 'CLEAR_SIGNUP_ERROR';
export const SIGNUP_FLOW_SCREEN_REQUEST = 'SIGNUP_FLOW_SCREEN_REQUEST';
export const SIGNUP_FLOW_SCREEN_SUCCESS = 'SIGNUP_FLOW_SCREEN_SUCCESS';
export const SIGNUP_FLOW_SCREEN_FAILURE = 'SIGNUP_FLOW_SCREEN_FAILURE';
export const NEXT_SCREEN_STEP = 'NEXT_SCREEN_STEP';
export const IAP_PRODUCTS_REQUEST = 'IAP_PRODUCTS_REQUEST';
export const IAP_PRODUCTS_SUCCESS = 'IAP_PRODUCTS_SUCCESS';
export const IAP_PRODUCTS_FAILURE = 'IAP_PRODUCTS_FAILURE';
export const IAP_BUY_REQUEST = 'IAP_BUY_REQUEST';
export const IAP_BUY_SUCCESS = 'IAP_BUY_SUCCESS';
export const IAP_BUY_FAILURE = 'IAP_BUY_FAILURE';
export const UPDATE_USER_PROFILE_REQUEST = 'UPDATE_USER_PROFILE_REQUEST';
export const UPDATE_USER_PROFILE_SUCCESS = 'UPDATE_USER_PROFILE_SUCCESS';
export const UPDATE_USER_PROFILE_FAILURE = 'UPDATE_USER_PROFILE_FAILURE';
export const ON_SCREEN_COMPLETE = 'ON_SCREEN_COMPLETE';
export const STRIPE_HOME_PLAN_SUMMARY_REQUEST = 'STRIPE_HOME_PLAN_SUMMARY_REQUEST';
export const STRIPE_HOME_PLAN_SUMMARY_SUCCESS = 'STRIPE_HOME_PLAN_SUMMARY_SUCCESS';
export const STRIPE_HOME_PLAN_SUMMARY_FAILURE = 'STRIPE_HOME_PLAN_SUMMARY_FAILURE';
export const SET_IS_INITIAL_DATA_LOADED = 'SET_IS_INITIAL_DATA_LOADED';
export const LOAD_USER_REQUEST = 'LOAD_USER_REQUEST';
export const LOAD_USER_SUCCESS = 'LOAD_USER_SUCCESS';
export const LOAD_USER_FAILURE = 'LOAD_USER_FAILURE';
export const GARMIN_ACCEPTED_AUTHORIZATION_REQUEST = 'GARMIN_ACCEPTED_AUTHORIZATION_REQUEST';
export const GARMIN_ACCEPTED_AUTHORIZATION_SUCCESS = 'GARMIN_ACCEPTED_AUTHORIZATION_SUCCESS';
export const GARMIN_ACCEPTED_AUTHORIZATION_FAILURE = 'GARMIN_ACCEPTED_AUTHORIZATION_FAILURE';
export const PRE_ACCOUNT_CREATE_SUBMIT = 'PRE_ACCOUNT_CREATE_SUBMIT';
export const CAPTURE_EMAIL_SUBMIT_REQUEST = 'CAPTURE_EMAIL_SUBMIT_REQUEST';
export const CAPTURE_EMAIL_SUBMIT_SUCCESS = 'CAPTURE_EMAIL_SUBMIT_SUCCESS';
export const CAPTURE_EMAIL_SUBMIT_FAILURE = 'CAPTURE_EMAIL_SUBMIT_FAILURE';

export const PRE_ACCOUNT_SET_PASSWORD_REQUEST = 'PRE_ACCOUNT_SET_PASSWORD_REQUEST';
export const PRE_ACCOUNT_SET_PASSWORD_SUCCESS = 'PRE_ACCOUNT_SET_PASSWORD_SUCCESS';
export const PRE_ACCOUNT_SET_PASSWORD_FAILURE = 'PRE_ACCOUNT_SET_PASSWORD_FAILURE';

export const SET_PASSWORD_SCREEN_MOUNTED_REQUEST = 'SET_PASSWORD_SCREEN_MOUNTED_REQUEST';
export const SET_PASSWORD_SCREEN_MOUNTED_SUCCESS = 'SET_PASSWORD_SCREEN_MOUNTED_SUCCESS';
export const SET_PASSWORD_SCREEN_MOUNTED_FAILURE = 'SET_PASSWORD_SCREEN_MOUNTED_FAILURE';

export const INSTALL_APP_SCREEN_MOUNTED_REQUEST = 'INSTALL_APP_SCREEN_MOUNTED_REQUEST';
export const INSTALL_APP_SCREEN_MOUNTED_SUCCESS = 'INSTALL_APP_SCREEN_MOUNTED_SUCCESS';
export const INSTALL_APP_SCREEN_MOUNTED_FAILURE = 'INSTALL_APP_SCREEN_MOUNTED_FAILURE';

export const APP_ONBOARDING_STARTED = 'APP_ONBOARDING_STARTED';
